import { render, staticRenderFns } from "./ZoneCard.vue?vue&type=template&id=c62b85c2&scoped=true"
import script from "./ZoneCard.vue?vue&type=script&lang=ts"
export * from "./ZoneCard.vue?vue&type=script&lang=ts"
import style0 from "./ZoneCard.vue?vue&type=style&index=0&id=c62b85c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b85c2",
  null
  
)

export default component.exports